/**
 * Get phone number from candidate, preferring one that matches the search
 * @param {Object} candidate - The candidate object
 * @param {string} searchValue - The search query to match against
 * @returns {string} The matched or first available phone number
 */
export const getPhone = (candidate, searchValue = "") => {
  const allPhones = [
    ...(candidate?.phones || []),
    ...(candidate?.phone ? [candidate.phone] : []),
  ];

  if (!allPhones.length) return "";

  const normalizedSearch = searchValue.replace(/\D/g, "");
  if (normalizedSearch) {
    const match = allPhones.find((phone) => {
      const normalizedPhone = phone.replace(/\D/g, "");
      return (
        normalizedPhone.includes(normalizedSearch) ||
        normalizedSearch.includes(normalizedPhone)
      );
    });
    if (match) return match;
  }

  return allPhones[0];
};
